import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Services.css';

const services = [
  {
    id: '01',
    title: 'Organizim Dasmash',
    subtitle: 'Wedding Planning',
    description: 'Planifikim i plote i dasmes tuaj, nga momenti i pare deri ne kengen e fundit. Cdo detaj e menduar me dashuri.',
    image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
    features: ['Venue Selection', 'Dekorim', 'Katering', 'Muzike & DJ'],
  },
  {
    id: '02',
    title: 'Dekorim & Dizajn',
    subtitle: 'Decor & Design',
    description: 'Transformojme hapesirat ne pervoja vizuale te jashtezakonshme me lule, drita, dhe elemente unike dizajni.',
    image: 'https://images.unsplash.com/photo-1478146059778-26028b07395a?w=800&q=80',
    features: ['Lule Freske', 'Ndricim Ambientit', 'Mobilje', 'Instalime Artistike'],
  },
  {
    id: '03',
    title: 'Evente Korporative',
    subtitle: 'Corporate Events',
    description: 'Organizim profesional i eventeve te korporatave, konferencave, dhe festave zyrtare me standarde te larta.',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
    features: ['Konferenca', 'Gala Darke', 'Team Building', 'Lancimet'],
  },
  {
    id: '04',
    title: 'Fishekzjarre & Efekte',
    subtitle: 'Pyrotechnics & Effects',
    description: 'Krijojme momente spktakolare me fishekzjarre profesionale, tymra ngjyrash, dhe efekte speciale per eventin tuaj.',
    image: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=800&q=80',
    features: ['Fishekzjarre', 'Cold Sparks', 'Tymra Ngjyrash', 'Konfeti'],
  },
  {
    id: '05',
    title: 'Fotografi & Video',
    subtitle: 'Photography & Film',
    description: 'Kaptojme cdo moment te rendesishem me fotografi dhe video kinematografike te cilesise se larte.',
    image: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800&q=80',
    features: ['Foto Profesionale', 'Video 4K', 'Drone Shots', 'Same-Day Edit'],
  },
];

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  return (
    <section className="services section-padding" id="services" ref={ref}>
      {/* Background accent */}
      <div className="services__bg-accent" />

      <div className="section-container">
        <motion.div
          className="services__header"
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="section-label">Sherbimet Tona</span>
          <h2 className="section-title">
            Cdo gje qe ju nevojitet per <em>eventin perfekt</em>
          </h2>
        </motion.div>

        {/* Services accordion - mobile */}
        <div className="services__accordion">
          {services.map((service, i) => (
            <motion.div
              key={service.id}
              className={`services__accordion-item ${activeIndex === i ? 'services__accordion-item--active' : ''}`}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              onClick={() => setActiveIndex(i)}
            >
              <div className="services__accordion-header">
                <div className="services__accordion-left">
                  <span className="services__accordion-num">{service.id}</span>
                  <div>
                    <h3 className="services__accordion-title">{service.title}</h3>
                    <span className="services__accordion-subtitle">{service.subtitle}</span>
                  </div>
                </div>
                <div className={`services__accordion-icon ${activeIndex === i ? 'services__accordion-icon--open' : ''}`}>
                  <span /><span />
                </div>
              </div>

              <div className="services__accordion-body">
                <div className="services__accordion-content">
                  <div className="services__accordion-img">
                    <img src={service.image} alt={service.title} loading="lazy" />
                  </div>
                  <div className="services__accordion-info">
                    <p className="services__accordion-desc">{service.description}</p>
                    <div className="services__accordion-features">
                      {service.features.map((f, j) => (
                        <span key={j} className="services__tag">{f}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Services grid - desktop interactive */}
        <div className="services__showcase">
          <div className="services__showcase-list">
            {services.map((service, i) => (
              <div
                key={service.id}
                className={`services__showcase-item ${activeIndex === i ? 'services__showcase-item--active' : ''}`}
                onMouseEnter={() => setActiveIndex(i)}
              >
                <span className="services__showcase-num">{service.id}</span>
                <div className="services__showcase-text">
                  <h3 className="services__showcase-title">{service.title}</h3>
                  <span className="services__showcase-subtitle">{service.subtitle}</span>
                </div>
                <svg className="services__showcase-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M7 17L17 7M17 7H7M17 7V17" />
                </svg>
              </div>
            ))}
          </div>

          <div className="services__showcase-preview">
            <motion.div
              className="services__showcase-image"
              key={activeIndex}
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
            >
              <img src={services[activeIndex].image} alt={services[activeIndex].title} />
              <div className="services__showcase-overlay">
                <p>{services[activeIndex].description}</p>
                <div className="services__showcase-tags">
                  {services[activeIndex].features.map((f, j) => (
                    <span key={j} className="services__tag">{f}</span>
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
